<template>
  <div
    id="styler"
    class="styler"
    :class="{'is-visible': isVisible, 'option-active': optionActive }"
    ref="styler"
    @click.stop >
    <ul class="styler-list">
      <li>
        <button
        class="styler-button"
        @click="updateOption('textColor')">
          <MergeIcon name="palettes"/>
        </button>
      </li>
      <!-- <li>
        <button
        class="styler-button"
        @click="updateOption('align')">
          <MergeIcon name="align"/>
        </button>
      </li> -->
      <li>
        <button
        class="styler-button"
        @click="updateOption('textStyle')">
          <MergeIcon name="textStyle"/>
        </button>
      </li>
      <li>
        <button
        class="styler-button"
        @click="updateOption('fontSize')">
          <MergeIcon name="fontSize"/>
        </button>
      </li>
      <li>
        <button
        class="styler-button"
        @click="$emit('removeItem', true)">
          <MergeIcon name="trash"/>
        </button>
      </li>
    </ul>

    <ul class="styler-list"
      v-show="currentOption === 'textColor'">
        <li>
          <ul class="colorer">
            <li v-for="color in colors">
              <input type="radio" v-model="colorerColor"
              :id="'color' + (color.charAt(0).toUpperCase() + color.slice(1))"
              name="colorer" :value="color"></input>
            </li>
          </ul>
        </li>
    </ul>

    <ul class="styler-list align"
      v-show="currentOption === 'textStyle'">
        <li>
          <button
          class="styler-button"
          :class="{active: styles.textStyle.bold}"
          @click="execute('textStyle', 'bold', !styleOptions.textStyle.bold)">
            <MergeIcon name="bold"/>
          </button>
        </li>
        <li>
          <button
          class="styler-button"
          :class="{active: styles.textStyle.italic}"
          @click="execute('textStyle', 'italic', !styleOptions.textStyle.italic)">
            <MergeIcon name="italic"/>
          </button>
        </li>
        <li>
          <button
          class="styler-button"
          :class="{active: styles.textStyle.underline}"
          @click="execute('textStyle', 'underline', !styleOptions.textStyle.underline)">
            <MergeIcon name="underline"/>
          </button>
        </li>
    </ul>

    <ul class="styler-list align"
      v-show="currentOption === 'fontSize'">
        <li>
          <button
          class="styler-button"
          :class="{active: styles.fontSize.twelve}"
          @click="execute('fontSize', 'twelve', !styleOptions.fontSize.twelve)">
            <MergeIcon name="twelve"/>
          </button>
        </li>
        <li>
          <button
          class="styler-button"
          :class="{active: styles.fontSize.forteen}"
          @click="execute('fontSize', 'forteen', !styleOptions.fontSize.forteen)">
            <MergeIcon name="forteen"/>
          </button>
        </li>
        <li>
          <button
          class="styler-button"
          :class="{active: styles.fontSize.sixteen}"
          @click="execute('fontSize', 'sixteen', !styleOptions.fontSize.sixteen)">
            <MergeIcon name="sixteen"/>
          </button>
        </li>
        <li>
          <button
          class="styler-button"
          :class="{active: styles.fontSize.eighteen}"
          @click="execute('fontSize', 'eighteen', !styleOptions.fontSize.eighteen)">
            <MergeIcon name="eighteen"/>
          </button>
        </li>
    </ul>
  </div>
</template>
<script>
  import MergeIcon from './Icons';
  export default {
    name: 'TextStyler',
    components: {
      MergeIcon
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      styles: {
        type: Object,
        default: {
          color: '',
          chosenSize: 14,
          textStyle: {
            bold: false,
            italic: false,
            underline: false,
          },
          fontSize: {
            twelve: false,
            forteen: false,
            sixteen: false,
            eighteen: false,
          }
        }
      }
    },
    data: function () { return ({
      colors: ['blue', 'green', 'red', 'black', 'white'],
      textColors: ['#4da1ff', '#38E4B7', '#EA4F52', '#000000', '#FFFFFF'],
      textColor: '',
      oldColorerColor: '',
      colorerColor: '',
      mouseTarget: '',
      currentOption: '',
      url: '',
      optionActive: false,
      styleOptions: this.styles
    }); },
    watch: {
      isVisible (val) {
        if (val) {

        } else {
          this.optionActive = false;
          this.currentOption = '';
        }
      },
      colorerColor: function () {
        this.changeColor();
      },
      styleOptions: {
        handler(newVal, oldVal) {
          this.$emit('styleOptions', {styles: this.styleOptions});
        },
        deep: true
      },
    },
    beforeDestroy: function beforeDestroy () {
      this.$refs.styler.remove();
    },
    methods: {
      updateOption: function updateOption (option) {
        this.currentOption = option;
        this.optionActive = true;
      },

      changeColor: function changeColor () {
        this.styleOptions.color = this.colorerColor;
      },

      execute: function execute (optionGroup, command, value) {
        if ( value === void 0 ) value = null;

        if (optionGroup == 'textStyle') {
          this.styleOptions.textStyle[command] = value;
        }

        if (optionGroup == 'fontSize') {
          let chosenSize = 14;
          Object.entries(this.styleOptions.fontSize).forEach(([size, value]) => {
            this.styleOptions.fontSize[size] = false
          });

          this.styleOptions.fontSize[command] = value;
          switch (command) {
            case 'twelve':
                chosenSize = 12;
              break;
            case 'forteen':
                chosenSize = 14;
              break;
            case 'sixteen':
                chosenSize = 16;
              break;
            case 'eighteen':
                chosenSize = 18;
              break;
            default:
              break;
          }
          this.styleOptions.font = chosenSize;
        }
      },

      showStyler: function showStyler (event) {
        event.stopPropagation();
        if (this.isVisible) { return; }
        this.isVisible = true;
      },
    }
  }
</script>
<style lang="scss" scoped>
  #styler {
    transform: translate3d(-10px, -80px, 0);
    will-change: transform;

    &.option-active {
      transform: translate3d(-10px, -130px, 0);
    }
  }
  .styler-button {
    &.active {
      background: #283039;
    }
  }
</style>
